import React from 'react';

const options = changeLanguage => {
  return [
    {
      action: () => {
        changeLanguage('pt-BR');
      },
      icon: <img src={'/images/brazil.png'} alt="Brazil" width={28.64} />,
      text: 'Português',
      language: /pt-BR/,
      imageUrl: '/images/brazil.png',
    },
    {
      action: () => {
        changeLanguage('en-US');
      },
      icon: <img src="/images/usa.png" alt="usa" width={28.64} />,
      text: 'English',
      language: /en+-?\w*/,
      imageUrl: '/images/usa.png',
    },
    {
      action: () => {
        changeLanguage('es');
      },
      icon: <img src="/images/spain.png" alt="es" width={28.64} />,
      text: 'Español',
      language: /es+-?\w*/,
      imageUrl: '/images/spain.png',
    },
  ];
};

export default options;
